import React, { useState } from "react";
import {
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Container,
  TextField,
  Button,
  Typography,
  Paper,
  Pagination,
  Box,
} from "@mui/material";
import { styled, ThemeProvider, createTheme } from "@mui/material/styles";
import backgroundImage from "../assets/background.jpg"; 
import { signupalums } from "../components/apifa"; 
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const theme = createTheme({
  spacing: 8,
});

const Root = styled("div")(({ theme }) => ({
  minHeight: "100vh",
  backgroundImage: `url(${backgroundImage})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: theme.spacing(2),
}));

const FormContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[5],
  backgroundColor: "rgba(255, 255, 255, 0.9)",
  maxWidth: "500px",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

const StyledForm = styled("form")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  "& .MuiTextField-root": {
    width: "100%",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      width: "80%",
    },
  },
}));

const SignupAlumni = () => {
  const [name, setName] = useState("");
  const [program, setProgram] = useState("");
  const [batch, setBatch] = useState("");
  const [grade, setGrade] = useState("");
  const [phonenumber, setphonenumber] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [tags, setTags] = useState("");
  const [history, setHistory] = useState([{ year: "", position: "", company: "" }]);
  const [image, setImage] = useState(null);

  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 1; // Number of entries per page

  const navigate = useNavigate();
  const handleHistoryChange = (index, field, value) => {
    const updatedHistory = [...history];
    updatedHistory[index][field] = value;
    setHistory(updatedHistory);
  };

  const handleAddHistory = () => {
    setHistory((prevHistory) => {
      const updatedHistory = [...prevHistory, { year: "", position: "", company: "" }];
      setCurrentPage(Math.ceil(updatedHistory.length / itemsPerPage)); // Set currentPage to the last page
      return updatedHistory;
    });
  };

  const handleRemoveHistory = (index) => {
    const updatedHistory = [...history];
    updatedHistory.splice(index, 1);
    setHistory(updatedHistory);
    // Adjust current page if the last entry of the page is removed
    if (currentPage > Math.ceil(updatedHistory.length / itemsPerPage)) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  // Pagination logic
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedHistory = history.slice(startIndex, startIndex + itemsPerPage);
  const handleImageUpload = (e) => {
    if (e.target.files.length > 0) {
      setImage(e.target.files[0]);
      console.log(e.target.files[0]);
    }
  };

  const handleSignup = async (e) => {
    e.preventDefault();

    if (!name || !email || !password || !program || !batch || !grade || !phonenumber || !image) {
      toast.error("All fields are required!");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("program", program);
      formData.append("email", email);
      formData.append("password", password);
      formData.append("batch", batch);
      formData.append("grade", grade);
      formData.append("phone_number", phonenumber);
      formData.append("tags", tags);
      formData.append("image", image);
      // Convert work histories to JSON string
    formData.append("work_histories", JSON.stringify(history));

    // Debug FormData
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    // const result = await signupalums(formData);
      console.log("File attached:", image);
      console.log("File attached:", formData.get("image"));

      const result = await signupalums(formData); 
console.log(result)
      // Use the signup function here
      if (result.status == 200) {
        toast.success("Signup successful!");
        setTimeout(() => navigate("/alumni/login/"), 1000);
      } else {
        toast.error(result.message || "Signup failed!");
      }
    } catch (error) {
      toast.error("Signup failed!");
      console.error("Error during signup:", error);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Root>
        <ToastContainer />
        <Container maxWidth="sm">
          <FormContainer>
            <Typography variant="h4" component="h1" gutterBottom>
              Alumni Sign Up
            </Typography>
            <StyledForm onSubmit={handleSignup} encType="multipart/form-data">
              {/* Your form fields here */}
              <TextField
                label="Name"
                variant="outlined"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <TextField
                label="Program"
                variant="outlined"
                value={program}
                onChange={(e) => setProgram(e.target.value)}
              />
              <FormControl variant="outlined" fullWidth>
  <InputLabel>Batch</InputLabel>
  <Select
    value={batch}
    onChange={(e) => setBatch(e.target.value)}
    label="Batch"
  >
    {Array.from({ length: 30 }, (_, i) => {
      const year = new Date().getFullYear() - i;
      return (
        <MenuItem key={year} value={year}>
          {year}
        </MenuItem>
      );
    })}
  </Select>
</FormControl>
           <br/>
              <TextField
                label="Last Grade Completed"
                variant="outlined"
                value={grade}
                onChange={(e) => setGrade(e.target.value)}
              />
              <TextField
                label="phonenumber"
                variant="outlined"
                value={phonenumber}
                onChange={(e) => setphonenumber(e.target.value)}
              />
              <TextField
                label="Email"
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <TextField
                label="Password"
                variant="outlined"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <TextField
                label="Tags (comma-separated)"
                variant="outlined"
                value={tags}
                onChange={(e) => setTags(e.target.value)}
              />
            <Button variant="contained" component="label" fullWidth sx={{ marginBottom: 2 }}>
  Upload Picture
  <input type="file" hidden accept="image/*" onChange={handleImageUpload} />
</Button>
              {image && <Typography>{image.name}</Typography>}
              <Typography variant="h6" sx={{ marginBottom: 2 }}>
                Work History
              </Typography>
              {paginatedHistory.map((entry, index) => {
          const actualIndex = startIndex + index; // Get index relative to the original history array
          return (
            <Box key={actualIndex} mb={2}>
              <TextField
                label="Year"
                variant="outlined"
                value={entry.year}
                onChange={(e) =>
                  handleHistoryChange(actualIndex, "year", e.target.value)
                }
                fullWidth
                sx={{ marginBottom: 1 }}
              />
              <TextField
                label="Position"
                variant="outlined"
                value={entry.position}
                onChange={(e) =>
                  handleHistoryChange(actualIndex, "position", e.target.value)
                }
                fullWidth
                sx={{ marginBottom: 1 }}
              />
              <TextField
                label="Company"
                variant="outlined"
                value={entry.company}
                onChange={(e) =>
                  handleHistoryChange(actualIndex, "company", e.target.value)
                }
                fullWidth
                sx={{ marginBottom: 1 }}
              />
              <Button
                onClick={() => handleRemoveHistory(actualIndex)}
                variant="outlined"
                color="error"
                sx={{ marginTop: 1 }}
              >
                Remove
              </Button>
            </Box>
          );
        })}
        <Button
          onClick={handleAddHistory}
          variant="contained"
          color="primary"
          sx={{ marginBottom: 2 }}
        >
          Add More History
        </Button>
        <Box display="flex" justifyContent="center" sx={{ marginTop: 2 }}>
          <Pagination
            count={Math.ceil(history.length / itemsPerPage)}
            page={currentPage}
            onChange={handlePageChange}
            color="primary"
          />
        </Box>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ marginTop: 2 }}
              >
                Sign Up
              </Button>
            </StyledForm>
            <Typography variant="body2" sx={{ marginTop: 2 }}>
              Already have an account? <Link to="/login">Login</Link>
            </Typography>
          </FormContainer>
        </Container>
      </Root>
    </ThemeProvider>
  );
};

export default SignupAlumni;
